module.exports = __webpack_public_path__ + "static/media/Inventory.207bf48c.svg";